<script setup lang="ts">
import { PrimaryButton } from '@/components/Buttons'
import { StackLayout } from '@/components/Layouts'
import FullScreenLoader from '@/components/LoadingSpinner/FullScreenLoader.vue'
import { BaseDialog } from '@/components/Modals/Dialog'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { ref } from 'vue'
import store from '../../../../../store'
import { EDeviceActions } from '../../../../../store/deviceStore/DeviceStoreTypes'
import { EStoreModules } from '../../../../../store/storeType'
import EditableStringField from '../../../../Fields/EditableFields/EditableStringField.vue'

type Props = {
    device: Partial<DeviceModel>
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const open = ref(false)
const isLoading = ref(false)
const serialNumber = ref<string>()

const handleConfirmButton = () =>
    store
        .dispatch(`${EStoreModules.DEVICE}/${EDeviceActions.CHANGE_SERIAL_NUMBER}`, {
            deviceId: props.device.device_id ?? props.device.id,
            serialNumber: serialNumber.value
        })
        .then(() => {
            emit('refresh')
            open.value = false
        })
</script>

<template>
    <FullScreenLoader :isLoading="isLoading" />
    <PrimaryButton
        :label="$t('device.changeSerialNumber.buttonTitle')"
        @click="open = true"
        v-bind="$attrs" />
    <BaseDialog
        :title="$t('device.changeSerialNumber.dialogTitle')"
        :open="open"
        @close="open = false"
        @confirm="handleConfirmButton"
        :disabled="!serialNumber"
        class="dialog-with-dropdown">
        <template #content>
            <StackLayout direction="column" class="full-width" :gap="4">
                <EditableStringField
                    isInEditMode
                    :label="$t('device.changeSerialNumber.dialogContent')"
                    :value="serialNumber"
                    @change="serialNumber = $event" />
            </StackLayout>
        </template>
    </BaseDialog>
</template>
